<template>
	<nut-navbar
		class="navbar"
		title="意见反馈"
		leftShow
		@on-click-back="goBack"
	>
	</nut-navbar>
	<div>
		<nut-input
			class="textarea"
			type="textarea"
			placeholder="请在此填写您宝贵的建议和意见！"
			v-model="content"
		/>

		<div class="btn-container">
			<nut-button
				class="btn"
				block
				type="primary"
				@click="handleSubmitFeedback"
			>
				提交
			</nut-button>
		</div>
	</div>
</template>

<script>
import { ref } from 'vue';
import { Toast } from '@nutui/nutui';
import useNavigate from '@/hooks/useNavigate';
import { siteApi } from '@/apis';

export default {
	name: 'Feedback',
	setup() {
		const { goBack } = useNavigate();
		const content = ref('');
		const handleSubmitFeedback = async () => {
			if (!content.value) return Toast.text('反馈内容不能为空');
			await siteApi.feedback_submit({
				words: content.value,
			});
			Toast.success('提交成功，感谢您的反馈！', {
				duration: 1000,
				onClose() {
					goBack();
				},
			});
		};

		return {
			content,

			goBack,
			handleSubmitFeedback,
		};
	},
};
</script>

<style lang="scss" scoped>
.textarea {
	:deep(.input-text) {
		height: 180px !important;
		&::placeholder {
			color: #999;
		}
	}
}

.btn {
	margin: 20px 15px;
	width: auto;
}
</style>
